module.exports = __webpack_public_path__ + "static/media/ic_personal_accident_myway.764f6014.svg";